// extracted by mini-css-extract-plugin
export default {"expenseListContainer":"ExpenseList_expenseListContainer__orAdK","transactionList":"ExpenseList_transactionList__Vzz2J"};